import React from "react";
import "./App.css";
import Timer from "./components/Timer";

function App() {
  return (
    <div className="App">
      <h1>React Chronometer</h1>
      <Timer />
    </div>
  );
}

export default App;
